var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSdFds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#EFF0F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 21.5L35 13.1667C35 11.9707 34.076 11 32.9375 11H21.25H15.0625C13.924 11 13 11.9707 13 13.1667V34.8333C13 36.0293 13.924 37 15.0625 37H22.708",
    stroke: "#8152E0",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17H30M18 21.2H30",
    stroke: "#8152E0",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1333 25.8667H24.1333",
    stroke: "#8152E0",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3541 27.967C32.8452 27.7876 32.3006 27.7328 31.7661 27.8073C31.2316 27.8818 30.7227 28.0834 30.2822 28.3952C29.8417 28.707 29.4824 29.1199 29.2344 29.5992C28.9864 30.0785 28.857 30.6103 28.857 31.15C28.857 31.6897 28.9864 32.2215 29.2344 32.7008C29.4824 33.1801 29.8417 33.593 30.2822 33.9048C30.7227 34.2166 31.2316 34.4182 31.7661 34.4927C32.3006 34.5672 32.8452 34.5124 33.3541 34.333M28.2916 30.025H32.2291M28.2916 32.275H32.2291M38.4166 31.15C38.4166 32.0364 38.242 32.9142 37.9028 33.7331C37.5636 34.5521 37.0664 35.2962 36.4396 35.923C35.8128 36.5498 35.0687 37.047 34.2497 37.3862C33.4308 37.7254 32.553 37.9 31.6666 37.9C30.7802 37.9 29.9025 37.7254 29.0835 37.3862C28.2646 37.047 27.5205 36.5498 26.8937 35.923C26.2669 35.2962 25.7697 34.5521 25.4304 33.7331C25.0912 32.9142 24.9166 32.0364 24.9166 31.15C24.9166 29.3598 25.6278 27.6429 26.8937 26.377C28.1595 25.1112 29.8764 24.4 31.6666 24.4C33.4568 24.4 35.1737 25.1112 36.4396 26.377C37.7055 27.6429 38.4166 29.3598 38.4166 31.15Z",
    stroke: "#8152E0",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdFds);
export default __webpack_public_path__ + "static/media/sd-fds.c46438a34cd3a2c8962bea3331495c10.svg";
export { ForwardRef as ReactComponent };